import { render, staticRenderFns } from "./_Water.vue?vue&type=template&id=665fe257&"
import script from "./_Water.vue?vue&type=script&lang=js&"
export * from "./_Water.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665fe257')) {
      api.createRecord('665fe257', component.options)
    } else {
      api.reload('665fe257', component.options)
    }
    module.hot.accept("./_Water.vue?vue&type=template&id=665fe257&", function () {
      api.rerender('665fe257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/_Water.vue"
export default component.exports